import Form from '../Form/Form'

export default function Content() {

  return (
    <main className="container">
      <Form />
    </main>
  )
}
